import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { FirebaseService } from '../auth/firebase.service';
import { environment } from '../../../environments/environment';
import { User } from '../../models/User';

@Injectable({
  providedIn: 'root'
})
export class UserService {

  constructor(private http: HttpClient,
              private firebaseService: FirebaseService
  ){}

  getUsers(){
    return this.http.get<User[]>(`${environment.URL_API}/api/users`, {headers: this.firebaseService.authHeader})
  }

  updateUserPassword(user_id: string, password: string){
    return this.http.patch<User>(`${environment.URL_API}/api/users/${user_id}/password`, {password}, {headers: this.firebaseService.authHeader})
  }

  deleteUserById(user_id: string){
    return this.http.delete(`${environment.URL_API}/api/users/${user_id}`, {headers: this.firebaseService.authHeader})
  }
}
